import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Play = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="play icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M5 19.198V4.80208C5 3.19172 6.80605 2.24168 8.13306 3.154L18.6028 10.3519C19.7587 11.1466 19.7587 12.8534 18.6028 13.6481L8.13306 20.846C6.80605 21.7584 5 20.8083 5 19.198Z"
    />
  </svg>
)
